<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('debt level')"
      :columns="columns"
      :column_search="true"
      resource_url="/debt-level/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <debt-level-modal ref="debt_level_modal" @success="refresh" />
  <log-modal ref="log_modal" />
  <view-modal ref="view_modal" :module_settings="module_settings" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  get,
  error_message,
  success_message,
  get_configuration,
  download,
  format_currency,
} from "@/utils";
import DebtLevelModal from "./debt_level_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import ViewModal from "./view_modal/Index.vue";
import moment from "moment";

export default {
  name: "DebtLevelsDatatable",
  components: { GenericTable, DebtLevelModal, LogModal, ViewModal },
  data() {
    let v = this;
    return {
      module_settings: {},
      columns: [
        {
          title: v.$t("name"),
          searchable: false,
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("dpi"),
          searchable: false,
          data: (row) => {
            return row.cui || "";
          },
        },
        {
          title: v.$t("promissory note number"),
          searchable: false,
          data: (row) => {
            return row.promissory_note_number || "";
          },
        },
        {
          title: v.$t("sirc data extraction result"),
          searchable: false,
          data: (row) => {
            if (row.extraction_result) {
              if (row.extraction_result.result == "ok")
                return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
                  "data extracted"
                )}</span>`;
              else
                return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
                  "error getting data"
                )}</span>`;
            } else return "";
          },
        },
        // {
        //   title: v.$t("report generation result"),
        //   searchable: false,
        //   data: (row) => {
        //     if (row.report_result) {
        //       if (row.report_result.result == "ok")
        //         return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
        //           "report generated"
        //         )}</span>`;
        //       else
        //         return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
        //           "error generating report"
        //         )}</span>`;
        //     } else return "";
        //   },
        // },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: false,
        //   width: "80%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("edit"),
              //   icon: "fa fa-edit",
              //   icon_class: "is-small",
              //   click: function (e) {
              //     // console.log("edit order", e.detail.uuid);
              //     v.$refs.dictamen_modal.edit_modal(e.detail.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete debt level?"),
                    v,
                    () => {
                      del("/debt-level", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("view"),
                icon: "fa fa-eye",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  v.$router.push({
                    path: `/debt-level/${e.detail.uuid}`,
                  });
                  // let uuid = e.detail.uuid;
                  // success_message(v.$t("debt level started, please wait..."));
                  // post("/debt-level/start", { uuid: uuid })
                  //   .then((r) => {
                  //     // success_message(v.$t(r));
                  //     // v.refresh();
                  //   })
                  //   .catch((error) => {
                  //     error_message(error);
                  //   });
                },
              },
              // {
              //   args: { uuid: row.uuid },
              //   tooltip: v.$t("view"),
              //   icon: "fa fa-eye",
              //   icon_class: "is-small has-text-primary",
              //   click: (e) => {
              //     v.$refs.view_modal.show_modal(row.uuid);
              //   },
              // },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
            ];

            if (row.user_data) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download"),
                icon: "fa fa-download",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  let uuid = e.detail.uuid;
                  v.$root.loader(true);

                  download(
                    `/debt-level/download?uuid=${e.detail.uuid}`,
                    `debt-level ${row.name} ${moment().format(
                      "YYYYMMDDHHmmss"
                    )}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    })
                    .finally(() => {
                      v.$root.loader(false);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.debt_level_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    get_configuration() {
      let v = this;
      get_configuration(v).then((settings) => {
        v.module_settings = settings;
      });
    },
  },
  mounted() {
    let vm = this;
    vm.refresh();
    vm.get_configuration();
  },
};
</script>

<style></style>
